import React from 'react';
import { Link } from 'react-router-dom';

function Sales() {
  return (
    <div>
      <h1>Sales Dashboard</h1>
      <Link to="/MOUProcess">MOU Process</Link><br />
      
      <Link to="/UpcomingPayments">Upcoming Payment Dates</Link><br />
      <Link to="/PaymentLink">Payment Link</Link><br />
      <Link to="/Centralisation">Centralisation</Link>
    </div>
  );
}

export default Sales;